function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape = function SvgShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    d: "M135.5 11h-.79l-.28-.27A6.47 6.47 0 0 0 136 6.5a6.5 6.5 0 1 0-6.5 6.5c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99 1.49-1.49zm-6 0c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5m.5-7h-1v2h-2v1h2v2h1V7h2V6h-2z",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-123)"
  }));
};
export default SvgShape;